import { injectIntl } from 'react-intl';

import Loading from './Loading';

export default injectIntl(Loading);
